import { MAX_PAGE_SIZE } from '@debbie/common/dist/index.js';
import { collectionEngineV1, drainPages } from '../apis.js';
const req = collectionEngineV1('/end-reasons');
// Pages to the end so callers keep getting the full set.
export const getAll = () => drainPages((page) => req('GET', `/?page=${page}&pageSize=${MAX_PAGE_SIZE}`), MAX_PAGE_SIZE);
export const create = (body) => req('POST', `/`, { body });
export const update = (id, body) => req('PATCH', `/${id}`, { body });
export const del = (id) => req('DELETE', `/${id}`);
//# sourceMappingURL=end-reasons.js.map